import mutations from "../mutations";

const usersNames = localStorage.getItem("usersNames") ? JSON.parse(localStorage.getItem("usersNames")) : null;

export default {
  namespaced: true,
  state: {
    trip: usersNames ? "UsersNames" : "Home",
    agendamientoMode: true,
    footerMode: false,
    showModal: false,
    specialGoBack: "",
    userData: {},
    modalState: {},
    historyState: [],
    valueProgress: 0,
    history: {
      "Home": "@",
      "ID": "Home",
      "ValidationData": "ID",
      "FormDocuments": "ValidationData",
      "FormDocumentsAdd": "FormDocuments",
      "FormDocumentsValidation": "FormDocuments",
      "FormDocumentsValidationInfo": "FormDocumentsValidation",
    },
    closeModal: null,
    loading: false,
    error: null,
  },
  mutations,
  actions: {
    changeTrip({ state, commit }, trip) {
      const historyLocal = JSON.parse(JSON.stringify(state.historyState));
      historyLocal.unshift(state.trip);

      commit("setState", { key: "historyState", value: historyLocal });
      commit("setState", { key: "trip", value: trip });
    },
    handleShowModal({ commit }, { showModal, modalState }) {
      commit("setState", { key: "showModal", value: showModal });
      commit("setState", { key: "modalState", value: modalState });
    },
    changeUserData({ state, commit }, data) {
      const newUserData = {
        ...state.userData,
        ...data,
      };
      commit("setState", { key: "userData", value: newUserData });
    },
    goBack({ state, commit }) {
      const historyLocal = JSON.parse(JSON.stringify(state.historyState));
      // const valueRoute = state.history[state.trip];

      // if (rootState.user.userData.dates.length) {
      //   commit("setState", { key: "history", value: {
      //     ...state.history,
      //     "FormDocumentsDate": "ValidationData",
      //     "FormDocumentsAdd": "FormDocumentsDate",
      //     "FormDocumentsValidation": "FormDocumentsDate",
      //     "FormDocumentsValidationInfo": "FormDocumentsValidation",
      //   }});
      // } else {
      //   commit("setState", { key: "history", value: {
      //     ...state.history,
      //     "FormDocuments": "ValidationData",
      //     "FormDocumentsAdd": "FormDocuments",
      //     "FormDocumentsValidation": "FormDocuments",
      //     "FormDocumentsValidationInfo": "FormDocumentsValidation",
      //   }});
      // }

      // if (state.specialGoBack) {
      //   commit("setState", {
      //     key: "trip",
      //     value: state.specialGoBack,
      //   });
      //   return;
      // }
      // if (state.history[state.trip] === "@") {
      //   goToRoute("/");
      // } else {
      //   if (goBackParameter) {
      //     state.history[state.trip] = goBackParameter;
      //   }
      //   if (valueRoute === "Home") {
      //     dispatch("eps/clearValues", {
      //       onlyEps: true,
      //     }, {
      //       root: true,
      //     });
      //   }
      //   commit("setState", {
      //     key: "trip",
      //     value: state.history[state.trip],
      //   });
      // }
      commit("setState", {
        key: "trip",
        value: state.historyState[0],
      });
      historyLocal.shift();
      commit("setState", { key: "historyState", value: historyLocal });
    },
  },
};
